import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  CircularProgress,
  Typography,
  useMediaQuery,
  Alert,
  Snackbar
} from "@mui/material";
import swal from "sweetalert";
import {
  CREATE_USER,
  UPDATE_USER,
  ACTIVATE_USER,
  DEACTIVATE_USER,
} from "../../data/userData";
import {
  fetchDataEngine,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../data/Axios/DynamicService";
import {
  allCompanies,
  allRegions,
  getrolesquery,
  allUsersQuery,
  allGenders,
} from "../../data/Axios/queries";
import {
  companyManagementUrl,
  roleManagemenUrl,
  setupManagementUrl,
  userManagementUrl,
} from "../../config";
import { usersField } from "../../data/DynamicTable/usersDynamicForms";
import Swal from "sweetalert2";
import { Formik } from "formik";
import * as yup from "yup";
import SignatureCanvas from "react-signature-canvas";
import axios from 'axios'; 

const base_url = roleManagemenUrl.uri;
const baseURL = process.env.REACT_APP_API_URL || 'https://matrix.mcb.co.ke/usermanagement';

// Helper function to get auth headers (copy this from your DynamicService)
const getAuthHeaders = (isMultipart = false) => {
  const token = localStorage.getItem("accessToken") || localStorage.getItem("token");
  const formattedToken = token ? `Bearer ${token.replace(/"/g, "")}` : "";
  
  const headers = {
    "Authorization": formattedToken,
  };
  
  // For multipart requests, don't set Content-Type (let browser set it with boundary)
  if (!isMultipart) {
    headers["Content-Type"] = "application/json";
  }
  
  return headers;
};

// Helper function to convert dataURL to File
const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, { type: mime });
};

async function executeGraphQLWithFiles(mutation, variables, base_url, isEditing = false) {
  try {
    // Check if any variable is a File or Blob
    const hasFiles = Object.values(variables).some(
      value => value instanceof File || value instanceof Blob
    );

    console.log("Has files:", hasFiles);
    console.log("Variables keys:", Object.keys(variables));

    if (!hasFiles) {
      console.log("No files detected, sending regular JSON request");
      const response = await axios.post(
        base_url,
        { query: mutation, variables },
        { headers: getAuthHeaders(false) }
      );
      return response.data;
    }

    console.log("Files detected, preparing multipart form data");
    
    // Handle file upload with FormData
    const formData = new FormData();
    
    // Create a clean copy of variables with file references
    const fileMap = {};
    const fileList = [];
    let fileCounter = 0;
    
    // Create operations object with file placeholders
    const operations = {
      query: mutation,
      variables: {}
    };
    
    // Process each variable
    Object.keys(variables).forEach(key => {
      if (variables[key] instanceof File || variables[key] instanceof Blob) {
        fileList.push(variables[key]);
        fileMap[fileCounter] = [`variables.${key}`];
        operations.variables[key] = null;
        fileCounter++;
      } else if (variables[key] && typeof variables[key] === 'object') {
        operations.variables[key] = variables[key];
      } else {
        operations.variables[key] = variables[key];
      }
    });
    
    formData.append('operations', JSON.stringify(operations));
    
    if (fileCounter > 0) {
      formData.append('map', JSON.stringify(fileMap));
      
      fileList.forEach((file, index) => {
        formData.append(index.toString(), file);
      });
    }
    
    // CRITICAL FIX: Add the exact headers from your original code
    const headers = {
      "Authorization": getAuthHeaders(true).Authorization,
      // Add these headers exactly as in your original code
      'X-APOLLO-OPERATION-NAME': isEditing ? 'EditUserWithSignature' : 'CreateUserWithSignature',
      'X-APOLLO-OPERATION-TYPE': 'multipart',
      'GraphQL-Preflight': '1',
      // Do NOT set Content-Type header - let browser set it
    };
    
    console.log("Request headers:", headers);
    
    const response = await axios.post(base_url, formData, {
      headers: headers
    });
    
    return response.data;
  } catch (error) {
    console.error('Error in executeGraphQLWithFiles:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
    }
    throw error;
  }
}

const UsersForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const tokenCompanyId = parseInt(decodedToken.CompanyId);
  const tokenRegionId = parseInt(decodedToken.RegionId);
  const tokenBranchId = parseInt(decodedToken.BranchId);
  const sigRef = useRef();
  const [roleData, setRoleData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState([]);
  const [showRegions, setShowRegions] = useState(false);
  const [showBranches, setShowBranches] = useState(false);
  const [genderData, setGenderData] = useState([]);
  const [branchIdData, setBranchIdData] = useState(null);
  const [regionIdData, setRegionIdData] = useState(null);
  const [showRegionsOnly, setShowRegionsOnly] = useState(false);
  
  // Signature related states
  const [existingSignature, setExistingSignature] = useState(null);
  const [signatureLoading, setSignatureLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const initialValues = {
    id: props.userData ? props.userData.id : "",
    firstName: props.userData ? props.userData.firstName : "",
    lastName: props.userData ? props.userData.lastName : "",
    email: props.userData ? props.userData.email : "",
    phone: props.userData ? props.userData.phone : "",
    username: props.userData ? props.userData.username : "",
    idno: props.userData ? props.userData.idno : "",
    roleId: props.userData ? props.userData.roleId : "",
    roleName: props.userData ? props.userData.roleName : "",
    companyId: props.userData ? props.userData.companyId : "",
    genderId: props.userData ? props.userData.genderId : "",
    regionId: props.userData ? props.userData.regionId : "",
    branchId: props.userData ? props.userData.branchId : "",
    signature: props.userData ? props.userData.signature : "",
  };

  const validationSchema = yup.object().shape({
    idno: yup
      .string()
      .matches(/^[0-9]{8}$/, "National ID must be exactly 8 digits")
      .required("National ID is required")
      .nullable(),
    email: yup
      .string()
      .email("Enter a valid email address")
      .required("Email is required")
      .nullable(),
    phone: yup
      .string()
      .matches(/^(0[17]\d{8}|\+254\d{9})$/, "Enter a valid phone number")
      .required("Phone is required")
      .nullable(),
    roleId: yup
    .number()
    .typeError("Role is required")
    .required("Role is required")
    .moreThan(0, "Role is required"),


  });

  const isNonMobile = useMediaQuery("(min-width:600px)");

  // Function to fetch user signature (adapted from PrintFeeNote.jsx)
  const fetchUserSignature = async (userId) => {
    if (!userId) return;
    
    setSignatureLoading(true);
    try {
      console.log("Fetching signature for user:", userId);

      const signatureQuery = `
        query {
          userSignature(userId: ${userId}) 
        }
      `;

      const response = await axios.post(
        userManagementUrl.uri,
        {
          query: signatureQuery
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/"/g, '')}`
          }
        }
      );

      console.log("Signature response:", response.data);

      if (response.data?.data?.userSignature) {
        const signaturePath = response.data.data.userSignature;
        
        // Construct the full URL to access the signature
        const cleanPath = signaturePath.startsWith('/') ? signaturePath.substring(1) : signaturePath;
        const fullSignatureUrl = `${baseURL.replace(/\/$/, '')}/${cleanPath.replace(/^\//, '')}`;
        
        console.log("Signature URL:", fullSignatureUrl);
        setExistingSignature(fullSignatureUrl);
        
        setSnackbar({
          open: true,
          message: 'Signature loaded successfully',
          severity: 'success'
        });
      } else {
        setSnackbar({
          open: true,
          message: 'No signature found for user',
          severity: 'info'
        });
      }
    } catch (err) {
      console.error("Error fetching signature:", err);
      setSnackbar({
        open: true,
        message: 'Failed to load signature',
        severity: 'error'
      });
    } finally {
      setSignatureLoading(false);
    }
  };

  // Alternative: Fetch signature as base64 (if static file serving isn't configured)
  const fetchSignatureAsBase64 = async (userId) => {
    if (!userId) return;
    
    setSignatureLoading(true);
    try {
      // First, get the signature path
      const signatureQuery = `
        query {
          userSignature(userId: ${userId}) 
        }
      `;

      const response = await axios.post(
        userManagementUrl.uri,
        { query: signatureQuery },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/"/g, '')}`
          }
        }
      );

      if (response.data?.data?.userSignature) {
        const signaturePath = response.data.data.userSignature;
        
        // Now fetch the actual image file as base64
        const cleanPath = signaturePath.startsWith('/') ? signaturePath.substring(1) : signaturePath;
        const imageUrl = `${baseURL}/${cleanPath}`;
        
        console.log("Fetching image from:", imageUrl);
        
        const imageResponse = await axios.get(imageUrl, {
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')?.replace(/"/g, '')}`
          }
        });
        
        // Convert to base64
        const base64 = btoa(
          new Uint8Array(imageResponse.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        );
        
        // Get content type from response or infer from file extension
        const contentType = imageResponse.headers['content-type'] || 
                           (signaturePath.endsWith('.png') ? 'image/png' : 
                            signaturePath.endsWith('.jpg') || signaturePath.endsWith('.jpeg') ? 'image/jpeg' : 
                            signaturePath.endsWith('.gif') ? 'image/gif' : 'image/png');
        
        const base64Image = `data:${contentType};base64,${base64}`;
        
        setExistingSignature(base64Image);
        setSnackbar({
          open: true,
          message: 'Signature loaded successfully',
          severity: 'success'
        });
      }
    } catch (err) {
      console.error("Error:", err);
      setSnackbar({
        open: true,
        message: 'Failed to load signature',
        severity: 'error'
      });
    } finally {
      setSignatureLoading(false);
    }
  };

  useEffect(() => {
    async function fetchAllData() {
      try {
        const returnFields = [
          "id",
          "role",
          "roleDescription",
          "roleGroupId",
          "roleGroup",
          "isActive",
          "statusFlag",
          "createdBy",
          "createdDate",
          "updatedBy",
          "updatedDate",
          "companyId",
          "company",
        ];
        const inputFields = { isActive: true };
        const Facts = await fetchDataEngine(
          "allRoles",
          "role",
          inputFields,
          returnFields,
          roleManagemenUrl.uri
        );
        setRoleData(Facts);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchAllData();
  }, []);

  useEffect(() => {
    async function fetchAllData() {
      try {
        const regionResponse = await graphqlQuery(
          allRegions,
          companyManagementUrl.uri
        );
        if (regionResponse) {
          setRegionData(regionResponse || []);
        }

        const companyResponse = await graphqlQuery(
          allCompanies,
          companyManagementUrl.uri
        );
        if (companyResponse) {
          setCompanyData(companyResponse || []);
        }

        // Fetch branch data if userData has regionId
        if (tokenRegionId) {
          const branchResponse = await fetchBranches(tokenRegionId);
          setBranchData(branchResponse || []);
        }

        // Determine visibility of regions and branches
        if (props.userData && props.userData.roleId) {
          handleRoleChange(props.userData.roleId);
        }
        const genderResponse = await graphqlQuery(
          allGenders,
          setupManagementUrl.uri
        );
        if (genderResponse) {
          setGenderData(genderResponse);
          console.log(genderResponse);
        }

        // Fetch existing signature if editing
        if (props.isEditing && props.userData && props.userData.id) {
          // Choose one method:
          await fetchUserSignature(props.userData.id);
          // await fetchSignatureAsBase64(props.userData.id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, [props.userData]);

  const fetchBranches = async (regionId) => {
    try {
      const inputFields = { regionId };
      const returnFields = ["id", "branchName"];
      const response = await fetchDataEngine(
        "allBranchesByColumnValues",
        "branchModel",
        inputFields,
        returnFields,
        companyManagementUrl.uri
      );
      return response.map((branch) => ({
        value: branch.id,
        label: branch.branchName,
      }));
    } catch (error) {
      console.error("Error fetching branches:", error);
      return [];
    }
  };

  const handleRoleChange = (roleId) => {
    const selectedRole = roleData.find((role) => role.id === parseInt(roleId));
    if (selectedRole) {
      const { roleGroupId } = selectedRole;
      const tokenRoleGroupId = parseInt(decodedToken.RoleGroupId);
      if (tokenRoleGroupId === 1 || tokenRoleGroupId === 2) {
        if (roleGroupId === 1 || roleGroupId === 2) {
          setShowRegions(false);
          setShowBranches(false);
          setShowRegionsOnly(false);
        } else if (roleGroupId === 3) {
          setShowRegionsOnly(true);
          setShowRegions(false);
          setShowBranches(false);
        } else if (roleGroupId === 4) {
          setShowRegions(true);
          setShowBranches(false);
          setShowRegionsOnly(false);
        }
      } else if (tokenRoleGroupId === 3) {
        if (roleGroupId === 3) {
          setShowRegionsOnly(false);
          setShowRegions(false);
          setShowBranches(false);
          setRegionIdData(tokenRegionId);
        } else if (roleGroupId === 4) {
          setShowRegions(false);
          setShowBranches(true);
          setShowRegionsOnly(false);
          setRegionIdData(tokenRegionId);
        }
      } else {
        if (roleGroupId === 4) {
          setShowRegions(false);
          setShowBranches(false);
          setShowRegionsOnly(false);
          setBranchIdData(tokenBranchId);
          setRegionIdData(tokenRegionId);
        }
      }
    }
  };

  const getOptions = (field) => {
    const name = field.name;
    switch (name) {
      case "genderId":
        return genderData.map((user) => ({
          value: user.id,
          label: user.gender,
        }));
      case "roleId":
        return roleData.map((role) => ({
          value: role.id,
          label: role.role,
        }));
      case "regionId":
        return regionData.map((region) => ({
          value: region.id,
          label: region.regionName,
        }));
      case "branchId":
        return branchData;
      case "companyId":
        return companyData.map((company) => ({
          value: company.id,
          label: company.companyName,
        }));
      default:
        return field.options || [];
    }
  };

 const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        id,
        firstName,
        lastName,
        email,
        phone,
        username,
        idno,
        roleId,
        regionId,
        branchId,
        genderId,
      } = values;

      // Get signature from canvas if available (new signature)
      let signatureFile = null;
      if (sigRef.current && !sigRef.current.isEmpty()) {
        const signatureDataUrl = sigRef.current.getTrimmedCanvas().toDataURL("image/png");
        signatureFile = dataURLtoFile(signatureDataUrl, "signature.png");
      }

      const userData = {
        id: id ? parseInt(id) : null,
        companyId: parseInt(tokenCompanyId),
        firstName,
        lastName,
        email,
        phone,
        username,
        idno,
        genderId: genderId || null,
        roleId: parseInt(roleId),
        roleGroupId: roleData.find((role) => role.id === parseInt(roleId))?.roleGroupId || null,
        regionId: regionId || regionIdData || null,
        branchId: branchId || branchIdData || null,
        signatureFilePath: null,
      };

      // Add updatedBy for edit
      if (props.isEditing) {
        userData.updatedBy = userId;
      } else {
        userData.createdBy = userId;
      }

      let mutation;
      let variables;

      if (props.isEditing) {
        // For edit, we need to include signatureFile in the mutation if provided
        mutation = `
          mutation EditUser($user: UsersDTOInput!, $signatureFile: Upload) {
            editUser(
              user: $user
              signatureFile: $signatureFile
            ) {
              id
              firstName
              lastName
              email
              username
              phone
              idno
              roleId
              roleGroupId
              roleName
              regionId
              region
              branchId
              branch
              departmentId
              department
              titleId
              title
              companyId
              company
              signatureFilePath
              isActive
              createdDate
              changePassword
            }
          }
        `;
        variables = {
          user: userData,
          signatureFile: signatureFile // Include signature file for edit
        };
      } else {
        // For create
        mutation = `
          mutation CreateUserWithSignature($user: UsersDTOInput!, $signatureFile: Upload) {
            createUserWithSignature(
              user: $user
              signatureFile: $signatureFile
            ) {
              id
              firstName
              lastName
              email
              username
              phone
              idno
              roleId
              roleGroupId
              roleName
              regionId
              region
              branchId
              branch
              departmentId
              department
              titleId
              title
              companyId
              company
              signatureFilePath
              isActive
              createdDate
              changePassword
            }
          }
        `;
        variables = {
          user: userData,
          signatureFile: signatureFile
        };
      }

      console.log("Executing mutation:", props.isEditing ? "EditUserWithSignature" : "CreateUserWithSignature");
      console.log("Variables:", variables);

      const response = await executeGraphQLWithFiles(
        mutation,
        variables,
        userManagementUrl.uri,
        props.isEditing // Pass isEditing flag
      );

      const responseData = props.isEditing 
        ? response.data?.editUser 
        : response.data?.createUserWithSignature;

      if (responseData) {       
        props.onClose();
        props.refetch();

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: props.isEditing ? "User updated successfully." : "User created successfully.",
        });
      } else {
        throw new Error(response.errors?.[0]?.message || `Failed to ${props.isEditing ? 'update' : 'create'} user`);
      }
    } catch (error) {
      console.error(`Error ${props.isEditing ? 'updating' : 'creating'} user:`, error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.errors?.[0]?.message || 
              error.message || 
              "An error occurred while processing your request.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  // Handle signature image error
  const handleSignatureError = (e) => {
    console.error("Failed to load signature image");
    e.target.style.display = 'none';
    setSnackbar({
      open: true,
      message: 'Failed to load signature image',
      severity: 'error'
    });
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  const title = props.isEditing ? "Edit User" : "Create User";
  const subtitle = props.isEditing ? "Edit an Existing User" : "Create a New User";

  const fields = [
    ...usersField,
    {
      name: "genderId",
      label: "Gender",
      type: "select",
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "roleId",
      label: "Role",
      type: "select",
      gridColumn: "span 2",
      required: true,
      parent: "main",
    },
    ...(showRegionsOnly
      ? [
          {
            name: "regionId",
            label: "Region",
            type: "select",
            gridColumn: "span 2",
          },
        ]
      : []),
    ...(showRegions
      ? [
          {
            name: "regionId",
            label: "Region",
            type: "select",
            gridColumn: "span 2",
            parent: "main",
          },
          {
            name: "branchId",
            label: "Branch",
            type: "select",
            gridColumn: "span 2",
            required: true,
            parent: "dependent",
            dependentOn: "regionId",
          },
        ]
      : []),
    ...(showBranches
      ? [
          {
            name: "branchId",
            label: "Branch",
            type: "select",
            gridColumn: "span 2",
            required: true,
          },
        ]
      : []),
  ];

  return (
    <Box m="20px">
      <Typography variant="h2" mb="10px">
        {title}
      </Typography>
      <Typography variant="subtitle1" mb="30px">
        {subtitle}
      </Typography>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              {fields.map((field, index) => {
                const name = field.name;
                const labelText = field.required
                  ? `${field.label} *`
                  : field.label;
                const isSelect = field.type === "select";
                const fieldOptions = getOptions(field);
                const hasError = touched[name] && !!errors[name];
                const helperText = hasError ? errors[name] : "";
                const sx = { gridColumn: field.gridColumn || "span 1" };

                if (isSelect) {
                  return (
                    <FormControl key={index} fullWidth error={hasError} sx={sx}>
                      <InputLabel>{labelText}</InputLabel>
                      <Select
                        name={name}
                        value={values[name] || ""}
                        onChange={(e) => {
                          handleChange(e);
                          if (name === "roleId") {
                            handleRoleChange(e.target.value);
                          } else if (name === "regionId") {
                            setFieldValue("branchId", "");
                            fetchBranches(e.target.value).then(
                              (branchOptions) => {
                                setBranchData(branchOptions || []);
                              }
                            );
                          }
                        }}
                        onBlur={handleBlur}
                        label={labelText}
                      >
                        {fieldOptions.map((opt) => (
                          <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {hasError && (
                        <FormHelperText>{helperText}</FormHelperText>
                      )}
                    </FormControl>
                  );
                } else {
                  return (
                    <TextField
                      key={index}
                      fullWidth
                      variant="filled"
                      type={field.type || "text"}
                      label={labelText}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values[name] || ""}
                      name={name}
                      error={hasError}
                      helperText={helperText}
                      sx={sx}
                    />
                  );
                }
              })}
            </Box>
            
            {/* Signature Section */}
            <Box sx={{ gridColumn: "span 1", mt: 2 }}>
              <Typography variant="h6" mb={1}>
                Digital Signature
              </Typography>

              {/* Show existing signature if available */}
              {props.isEditing && existingSignature && (
                <Box mb={3}>
                  <Typography variant="body2" color="primary" gutterBottom>
                    Existing Signature:
                  </Typography>
                  <Box sx={{ 
                    border: '1px solid #00A676', 
                    borderRadius: '8px', 
                    p: 2, 
                    backgroundColor: '#f5f5f5',
                    display: 'inline-block'
                  }}>
                    <img
                      src={existingSignature}
                      alt="Existing signature"
                      style={{ 
                        maxWidth: '200px', 
                        maxHeight: '50px',
                        objectFit: 'contain'
                      }}
                      onError={handleSignatureError}
                    />
                  </Box>
                  <Typography variant="caption" display="block" color="textSecondary" sx={{ mt: 1 }}>
                    This signature will be kept if you don't draw or upload a new one.
                  </Typography>
                </Box>
              )}

              {/* Show loading indicator while fetching signature */}
              {props.isEditing && signatureLoading && (
                <Box display="flex" alignItems="center" mb={2}>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  <Typography variant="body2">Loading existing signature...</Typography>
                </Box>
              )}

              {/* DRAW SIGNATURE PAD with thinner drawing*/}
              <Typography variant="body2" mb={1}>
                Draw New Signature:
              </Typography>

              <SignatureCanvas
                ref={sigRef}
                penColor="black"
                penWidth={1}
                minWidth={0.5} 
                maxWidth={1.5}  
                canvasProps={{
                  width: 200,
                  height: 50,
                  className: "signatureCanvas",
                  style: {
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                  },
                }}
                onEnd={() => {
                  if (sigRef.current) {
                    const data = sigRef.current.getTrimmedCanvas().toDataURL("image/png");
                    setFieldValue("signature", data);
                  }
                }}
              />

              <Button
                sx={{ ml: 1, mt: 1 }}
                size="small"
                variant="outlined"
                color="error"
                onClick={() => {
                  if (sigRef.current) {
                    sigRef.current.clear();
                    setFieldValue("signature", "");
                  }
                }}
              >
                Clear Drawn Signature
              </Button>

              {/* OR UPLOAD SIGNATURE FILE */}
              <Typography variant="body2" mt={3} mb={1}>
                Or Upload New Signature File:
              </Typography>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                      setFieldValue("signature", reader.result);
                    };
                    reader.readAsDataURL(file);
                  }
                }}
              />

              {/* SIGNATURE PREVIEW (New Signature) */}
              {values.signature && (
                <Box mt={3}>
                  <Typography variant="body2">New Signature Preview:</Typography>
                  <img
                    src={values.signature}
                    alt="new-signature-preview"
                    style={{ maxWidth: "250px", border: "1px solid #eee" }}
                  />
                </Box>
              )}
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                variant="contained"
                disabled={isSubmitting}
                startIcon={
                  isSubmitting ? <CircularProgress size={20} /> : null
                }
                sx={{
                  backgroundColor: "#00A676",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#00A676",
                    boxShadow: "0px 4px 12px rgba(0, 166, 118, 0.3)",
                  },
                  "&:disabled": {
                    backgroundColor: "#B0B0B0",
                    color: "white",
                  },
                }}
              >
                {isSubmitting
                  ? props.isEditing
                    ? "Updating..."
                    : "Saving..."
                  : props.isEditing
                  ? "Update User"
                  : "Create User"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UsersForm;